__webpack_require__.p = "/funiro/";